
import { NOTIFICATION_TYPE } from 'constant';
import { Notification } from 'models';
import { getDispatch } from 'redux/store';
import { ACTIONS_TYPES } from '../helper';

export default {
  clear: async () => {
    const dispatch = getDispatch();

    dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: {
        notifications: [],
      },
    });
  },

  add: async ({
    type = NOTIFICATION_TYPE.SUCCESS,
    action,
    message,
  }) => {
    const dispatch = getDispatch();

    dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: {
        notifications: [Notification({
          type,
          action,
          message,
        })],
      },
    });
  },
};
